// hook
import { useCart } from "./../../context/cartContext";
import { IconTrash } from "@tabler/icons-react";
import { splitNumber } from "../../features/splitNumber/splitNumber";
// useEffect
import { useEffect, useState } from "react";
import { GetCarts } from "../../services/panel/cart/getCart";
import useGetData from "../../hook/getData";
// @ts-ignore
import Cookies from "js-cookie";
import { useMutation } from "@tanstack/react-query";
import { toastOptions } from "../../features/toast/toast";
import { toast } from "react-toastify";
import { EditCart } from "../../services/panel/cart/editCard";
import { RemoveCart } from "../../services/panel/cart/removeCart";
import { Link } from "react-router";

const CartModal = () => {
    const { cart, increaseQty, decreaseQty, removeFromCart } = useCart();
    const { data: carts, isLoading, refetch } = useGetData(['carts'], GetCarts)
    let [cartIndex, setIndex] = useState()
    let [load, setLoad] = useState<boolean>(false);
    const totalPrice = cart.reduce((sum, item) => sum + item.item_price * item.qty, 0);
    useEffect(() => {
        window.scrollTo(0, 0);
        document.getElementById('pages-header')?.classList.remove('d-none');
    }, [])
    const Cartmutation = useMutation({
        mutationFn: EditCart,
        onSuccess: () => {
            refetch();
            setLoad(false)
        },
        onError: (error: any) => {
            setLoad(false)
            const errors: any = error.response.data?.message;
            if (errors) {
                for (const [, messages] of Object.entries(errors)) {
                    (messages as string[]).forEach((message) => {
                        toast.error(message, toastOptions);
                    });
                }
            }
        },
    });
    const rmmutation = useMutation({
        mutationFn: RemoveCart,
        onSuccess: () => {
            refetch();
        },
        onError: (error: any) => {
            const errors: any = error.response.data?.message;
            if (errors) {
                for (const [, messages] of Object.entries(errors)) {
                    (messages as string[]).forEach((message) => {
                        toast.error(message, toastOptions);
                    });
                }
            }
        },
    });
    const decreaseQtyL = (id: any, quantity: any, index: any) => {
        let data = {
            id: id,
            quantity: quantity - 1,
            "_method": "PUT",
        }
        Cartmutation.mutate(data)
        setIndex(index)
        setLoad(true)
    }
    const increaseQtyL = (id: any, quantity: any, index: any) => {
        let data = {
            id: id,
            quantity: quantity + 1,
            "_method": "PUT",
        }
        Cartmutation.mutate(data)
        setIndex(index)
        setLoad(true)
    }
    const removeFromCartL = (id: any) => {
        rmmutation.mutate(id)
    }
    return (
        <>
            {isLoading ? (
                <>
                    <div className="container h-100 mt-5">
                        <div className="row h-100 justify-content-center py-5 align-items-center">
                            <div className="col-md-6 text-center">
                                <img alt="logo" className="acband-price-icon animate-logo" src={require('../../assets/media/logo/final.png')} />
                                <p className="fw-bold mt-3">
                                    در حال بارگزاری..
                                </p>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <section className="bg-white container">
                        <div className="row gy-4 py-md-3 py-4">
                            <p className="card-text fw-bold text-site">
                                سبد خرید
                            </p>
                            <div className="col-lg-9 order-md-0 order-1">
                                <div className="card card-body shadow border-0">
                                    <div className="row justify-content-center gy-4">
                                        {!Cookies.get('agent_token') ? (<>
                                            {cart.map((item: any) => (
                                                <div key={`${item.product_id}-${item.variation_id}`} className="col-md-12">
                                                    <div className="card card-body border-1">
                                                        <div className="profile">
                                                            <div className="d-flex">
                                                                <div className="d-flex justify-content-center">
                                                                    <img alt="category" src={item.item_image} />
                                                                </div>
                                                                <div className="w-25">
                                                                    <p className="text-center text-split w-100 ms-2 mb-0 fw-bold font-medium-lg mt-3">
                                                                        {item.item_name}
                                                                    </p>
                                                                    <p>
                                                                        {item.item_var_name}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="d-flex align-items-center justify-content-between">
                                                                <span className="mt-2 fw-bold">
                                                                    {splitNumber(item.item_price)}
                                                                    <span className="ms-2">
                                                                        تومان
                                                                    </span>
                                                                </span>
                                                                <div className="d-flex">
                                                                    <div className="d-flex gap-2 align-items-center">
                                                                        <button className="btn btn-primary font-medium p-3 py-2" onClick={() => decreaseQty(item.product_id, item.variation_id)}>-</button>
                                                                        <span>{item.qty}</span>
                                                                        <button className="btn btn-primary font-medium p-3 py-2" onClick={() => increaseQty(item.product_id, item.variation_id)}>+</button>
                                                                    </div>
                                                                    <button className="btn-danger btn ms-2 font-medium p-1" onClick={() => removeFromCart(item.product_id, item.variation_id)}>
                                                                        <IconTrash />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </>) : (<>

                                            <>
                                                {carts?.cartItems.length !== 0 ? (
                                                    <>
                                                        {carts?.cartItems?.map((item: any, index: number) => (
                                                            <div key={`${item.product_id}-${item.variation_id}`} className="col-md-12">
                                                                <div className="card card-body border-1">
                                                                    <div className="profile">
                                                                        <div className="d-flex">
                                                                            <div className="d-flex justify-content-center">
                                                                                <img alt="category" src={`https://dash.arascome.com/uploads/files/products/images/${item.product.primary_image}`} />
                                                                            </div>
                                                                            <div className="w-25">
                                                                                <p className="text-center text-split w-100 ms-2 mb-0 fw-bold font-medium-lg mt-3">
                                                                                    {item.product.name}
                                                                                </p>
                                                                                <p>
                                                                                    {item.variation?.value ?? ''}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="d-flex align-items-center justify-content-between">
                                                                            <span className="mt-2 fw-bold">
                                                                                {splitNumber(item.variation ? item.variation?.sale_price ? item.variation?.sale_price : item.variation?.price : item.price)}
                                                                                <span className="ms-2">
                                                                                    تومان
                                                                                </span>
                                                                            </span>
                                                                            <div className="d-flex">
                                                                                <div className="d-flex gap-2 align-items-center">
                                                                                    <button className="btn btn-primary font-medium p-3 py-2" onClick={() => increaseQtyL(item.id, item.quantity, index)}>+</button>
                                                                                    {load && index === cartIndex ? (
                                                                                        <>
                                                                                            <span className="spinner-border"></span>
                                                                                        </>
                                                                                    ) : (
                                                                                        <span>{item.quantity}</span>
                                                                                    )}
                                                                                    <button className="btn btn-primary font-medium p-3 py-2" onClick={() => decreaseQtyL(item.id, item.quantity, index)}>-</button>
                                                                                </div>
                                                                                <button className="btn-danger btn ms-2 font-medium p-1" onClick={() => removeFromCartL(item.id)}>
                                                                                    <IconTrash />
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </>
                                                ) :
                                                    <p className="text-danger text-center mb-0 fw-bold">سبد خرید خالی است !</p>
                                                }
                                            </>
                                        </>)}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 order-md-1 order-0">
                                <div className="card card-body border-0 shadow">
                                    <ul className="list-group mt-3">
                                        <li className="list-group-item">
                                            <div className="d-flex justify-content-between">
                                                <span>قیمت کل :</span>
                                                <span className="text-split fw-bold">
                                                    {Cookies.get('agent_token') ? splitNumber(carts?.cartTotalAmount) : splitNumber(totalPrice)}
                                                    <span className="ms-2">
                                                        تومان
                                                    </span>
                                                </span>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="d-flex justify-content-between">
                                                <span>گارانتی :</span>
                                                <span className="text-split">
                                                    دارای گارانتی
                                                </span>
                                            </div>
                                        </li>
                                    </ul>
                                    {Cookies.get('agent_token') ? (
                                        <Link to='/shop' className="btn d-md-block d-none btn-primary mt-4">
                                            ادامه فرایند خرید
                                        </Link>
                                    ) : (
                                        <button data-bs-toggle="modal" data-bs-target="#agent" className="btn d-md-block d-none btn-primary mt-4">
                                            ادامه فرایند خرید
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="d-md-none d-inline-block mobile-menu d-flex justify-content-center position-relative">
                        <div
                            className="header-mobile fixed-bottom py-2 d-md-none d-inline-block position-fixed shadow shadow-lg">
                            <div className="p-3">
                                <div className="d-flex align-items-center justify-content-between">
                                    {Cookies.get('agent_token') ? (
                                        <Link id="link-next" to='/shop' className="btn btn-primary  text-white">
                                            ادامه فرایند خرید
                                        </Link>
                                    ) : (
                                        <button data-bs-toggle="modal" data-bs-target="#agent" className="btn btn-primary">
                                            ادامه فرایند خرید
                                        </button>
                                    )}
                                    <ul className="list-group">
                                        <li className="list-group-item">
                                            <div className="d-flex justify-content-between">
                                                <span>قیمت :</span>
                                                <span className="text-split fw-bold">
                                                    {Cookies.get('agent_token') ? splitNumber(carts?.cartTotalAmount) : splitNumber(totalPrice)}
                                                    <span className="ms-1">
                                                        تومان
                                                    </span>
                                                </span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )
            }
        </>
    );
};

export default CartModal;